import { faVideo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function sendStreamConf() {
    return (
        <div data-cy="historic-icon-ipcamera-sendStreamConf">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.ipcamera.sendStreamConf" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faVideo} size="lg" />
            </Whisper>
        </div>
    );
}
